import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { WithStyles, Theme, createStyles, withStyles, Typography, Icon } from '@material-ui/core'
import autobind from 'autobind-decorator'
import { IconBtn } from 'src/shared/IconBtn'
import { PaginateAction } from 'src/core/redux/action/paginateAction'
import { fetchProductsDette } from 'src/core/redux/action/productsAction'
import { ProductCriteria } from 'src/type/criteria/productCriteria'
import ProductsFlow from 'src/page/Consumer/Products/ProductsFlow'
import {css} from 'src/conf/style'
import { fade } from '@material-ui/core/styles/colorManipulator'

const styles = (t: Theme) => createStyles({
  root:{
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between'
  },
  flowWpr: {
      display: 'flex',
      flexDirection: 'row',
      [t.breakpoints.down('md')]: {
        flexDirection: 'column'
      }
  },
  btn: {
      borderRadius: 0,
      margin: `${t.spacing.unit}px 0`,
      color: t.palette.primary.main
  },
  disabled: {
      pointerEvents: 'none',
      color: '#f7f7f7 !important'
  },
  fetchIcon: {
    [t.breakpoints.down('md')]: {
        transform: 'rotate(90deg)'
      }
  },
  alertEmpty: {
    ...css.flexFullCenter,
      width: '100%'
  },
  title: {
    padding: '5px 10px',
    textAlign: 'center',
    background: fade(t.palette.primary.main, .16),
    color: t.palette.primary.main
  }
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  dispatch: any;
  filter?: string;
}

const paginateName = `productsDette`;
const paginateAction = fetchProductsDette;
const actions = new PaginateAction<any>(paginateName, paginateAction)

class ProductsDette extends React.Component<IProps, {}> {

  componentDidMount(){
      const {updateCriteriaByObject} = this.props
      updateCriteriaByObject(
        {
            "sort_by": "created_at",
            "order_by": "desc",
            "category_principale": "dette",
            "limit": 4
        }
      )
  }

  render() {
    const {t, classes, products, criteria, totalSize} = this.props
    return (
        <>
        {products &&
            <div className={classes.root}>  
                <Typography variant="h6" gutterBottom className={classes.title}>{t.products_dette}</Typography>
                    <div className={classes.flowWpr}>
                        <IconBtn 
                            onClick={this.fetchBefore}
                            className={[classes.btn, (criteria.offset === 0 || this.shouldHiddenFlow()) ? classes.disabled : ''].join(' ')}
                        >
                            <Icon className={classes.fetchIcon} fontSize="large">keyboard_arrow_left</Icon>
                        </IconBtn>
                        <ProductsFlow entities={products} shouldHidden={criteria.category_principale !== 'dette'}/>
                        <IconBtn 
                            onClick={this.fetchAfter}
                            className={[classes.btn, ((criteria.offset + 4) >= totalSize || this.shouldHiddenFlow()) ? classes.disabled : ''].join(' ')}
                        >
                            <Icon className={classes.fetchIcon} fontSize="large">keyboard_arrow_right</Icon>
                        </IconBtn>
                    </div>
            </div>
        }
        </>
    )
  }

  @autobind
  private shouldHiddenFlow(){
    return this.props.criteria.category_principale !== 'dette'
  }
  
  @autobind
  private fetchBefore(){
    this.props.updateCriteria("offset", this.props.criteria.offset - 4)
  }

  @autobind
  private fetchAfter(){
    this.props.updateCriteria("offset", this.props.criteria.offset + 4)
  }

}

const state2props = (state: RootState) => ({
    criteria: state.paginate.productsDette.criteria,
    products: state.paginate.productsDette.entities,
    totalSize: state.paginate.productsDette.total_size
});

const dispatch2props = (dispatch: any) => ({
    updateCriteria: (name: string, value: any) => dispatch(actions.updateCriteria(name, value)),
    updateCriteriaByObject: (object: any) => dispatch(actions.updateCriteriaByObject(object)),
    fetch: (c?: ProductCriteria) => dispatch(fetchProductsDette(c)),
});

export default compose(
    withI18n,
    withStyles(styles),
    connect(state2props, dispatch2props),
)(ProductsDette)



// WEBPACK FOOTER //
// ./src/page/Consumer/Products/Flow/ProductsDette.tsx